import React from "react";
import { CircularProgress } from "@mui/material";

const SubmitButton = ({ loading, onClick, label }) => {
  return (
    <div className="col-12">
      <div className="d-grid">
        <button
          type="submit"
          className="btn btn-primary border-0 outline-0"
          disabled={loading}
          onClick={onClick}
        >
          {loading ? (
            <>
              <CircularProgress className="text-white h-auto w-17" />
            </>
          ) : (
            <>{label}</>
          )}
        </button>
      </div>
    </div>
  );
};

export default SubmitButton;
